export default {
  SHOP_NAME: 'Müller’s Naturhof',
  ORG_NAME: 'Premium Pet Products GmbH',
  SEARCH_PAGE_TITLE: "Müller's Naturhof - Suchergebnisse",
  PALI_PRODUCTS: [],
}
